






















































import mixins from 'vue-typed-mixins';
import WorksheetLayout from './WorksheetLayout.vue';
import WorksheetUtils, { Worksheet } from '@/utils/WorksheetUtils';
import cloneDeep from 'lodash.clonedeep';
import { SurveyGroup } from '@/utils/SurveyUtils';
export default mixins().extend({
  components: {
    WorksheetLayout,
  },

  props: {
    surveygroup: {
      type: Object as () => SurveyGroup,
    },
    pristine: {
      type: Object as () => Worksheet,
    },
  },

  data(): {
    worksheet?: Worksheet;
  } {
    return {
      worksheet: undefined,
    };
  },

  watch: {
    pristine() {
      this.worksheet = cloneDeep(this.pristine);
    },
  },

  methods: {
    cancel() {
      this.$emit('submit', undefined);
    },

    async submit() {
      if (this.worksheet) {
        try {
          (this.$refs.alert as any)?.hide('submit');

          if (this.worksheet.id) {
            await WorksheetUtils.api.update(this.worksheet);
          } else {
            this.worksheet = await WorksheetUtils.api.add(this.worksheet);
          }

          this.$emit('submit', this.worksheet);
        } catch (error) {
          (this.$refs.alert as any)?.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },
  },
});
